import styled from 'styled-components';
import {
  companyColor,
  spacing,
  fluidFont,
  font,
  device,
} from 'styles/theme';

export const HeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'title'
    'children'
    'actions';
  gap: 0.75rem;
  width: 100%;
  align-items: start;
  margin-bottom: ${spacing('medium')};

  @media only screen and (${device('laptop')}) {
    grid-template-columns: minmax(0, 1fr) max-content max-content;
    grid-template-areas: 'title children actions';
    gap: 0.5rem;
    align-items: center;
  }
`;

export const Title = styled.span`
  grid-area: title;
  min-width: 0;
  display: block;
  font-family: ${font('semibold')};
  ${fluidFont('24px', '27px')};
  color: ${companyColor('font')};
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const Children = styled.div`
  grid-area: children;
  display: flex;
  flex-wrap: wrap;
  min-width: 0;
  gap: ${spacing('default')};
`;

export const ActionItems = styled.div`
  grid-area: actions;
  justify-self: start;
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing('default')};

  @media only screen and (${device('laptop')}) {
    justify-self: end;
  }
`;
